import React from "react";
import styles from "./PrivacyPolicy.module.css";

export default function PrivacyPolicy() {
  return (
    <div className={styles.container}>
      <div>
        <h1>Privacy Policy</h1>

        <p>
      RisingDSP takes the protection of your personal data seriously. 
      The company process your data in accordance with the EU General Data Protection Regulation (GDPR)
       and applicable Austrian data protection laws.
        </p>

        <h2>1. Data Controller</h2>
        <p>
          RisingDSP<br />
          Jahnstraße 14, 6020 Innsbruck, Austria<br />
          Email: info@risingdsp.com
        </p>

        <h2>2. No Cookies</h2>
        <p>
          This website does not use cookies for tracking, advertising or analytics.
          No personal tracking cookies are stored in your browser.
        </p>

        <h2>3. Collected Data</h2>
        <p>
          We only collect personal data that is necessary to provide our services,
          such as:
          <br />• Email address (account creation, communication)
          <br />• Billing information (for purchases)
          <br />• License information (for product activation)
        </p>

        <h2>4. Purpose of Processing</h2>
        <p>
          Your data is used exclusively for:
          <br />• Providing access to our software products
          <br />• Processing payments
          <br />• Managing licenses
          <br />• Customer support and communication
        </p>

        <h2>5. Third-Party Services</h2>
        <p>
          Trusted third-party providers are used to operate our services:
          <br /><br />
          • Hostinger – hosting and deployment infrastructure<br />
          • Stripe – payment processing<br />
          • Moonbase – license management system<br />
          • Brevo – email communication service<br />
          • Cloudflare – secure storage of invoices and delivery optimization
        </p>

        <h2>6. Data Storage</h2>
        <p>
          Your data is stored securely and only for as long as necessary for the
          purposes stated above or as required by law.
        </p>

        <h2>7. Your Rights</h2>
        <p>
          Under GDPR, you have the right to:
          <br />• Access your personal data
          <br />• Request correction or deletion
          <br />• Restrict processing
          <br />• Data portability
          <br />• Withdraw consent at any time
        </p>

        <h2>8. Contact</h2>
        <p>
          For any privacy-related questions, contact at:
          <br />
          info@risingdsp.com
        </p>
      </div>
    </div>
  );
}